module.exports = __webpack_public_path__ + "media/a_greener_chiller_world.cda13e3a.ogg";